export default [
  { key: 'status', val: 'Status' },
  { key: 'amount', val: 'Amount' },
];
